"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawShaderMaterial = void 0;
/*
 * Copyright (C) 2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
const harp_utils_1 = require("@here/harp-utils");
const THREE = require("three");
/**
 * Material that converts webgl1 shaders to webgl2 compatible code when renderer uses a WebGL2
 * context.
 */
class RawShaderMaterial extends THREE.RawShaderMaterial {
    /**
     * The constructor of `WebGL1RawShaderMaterial`.
     *
     * @param params - Optional material parameters.
     */
    // tslint:disable-next-line: deprecation
    constructor(params) {
        super(params);
    }
    // overrides with THREE.js base classes are not recognized by tslint.
    // tslint:disable-next-line: explicit-override
    onBeforeCompile(shader, renderer) {
        if (renderer.capabilities.isWebGL2) {
            shader.vertexShader = harp_utils_1.convertVertexShaderToWebGL2(shader.vertexShader);
            shader.fragmentShader = harp_utils_1.convertFragmentShaderToWebGL2(shader.fragmentShader);
        }
    }
}
exports.RawShaderMaterial = RawShaderMaterial;
//# sourceMappingURL=RawShaderMaterial.js.map